module.exports = __webpack_public_path__ + "img/xw2.a4e442dc.png";